<template>
	<div>
		UUID：
		<input v-model="payInfo.uuid" placeholder="用户ID" />

		<br/>
		OrderId:
		<input v-model="payInfo.orderId" placeholder="订单ID" />

		<br/>
		payId:
		<input v-model="payInfo.payId" placeholder="支付单ID" />

		<br/>
		terminal:
		<input v-model="payInfo.terminal" placeholder="终端" />

		<br/>
		<button @click="createPay">支付</button>
	</div>
</template>

<script type="text/javascript">
import {createPayH5} from '@/interface/paycenter/paycenter';

export default {
    data(){
    	return {
			payInfo:{
				uuid: 511,
				orderId: 1206,
				payId: 1182,
				terminal:'Wap'
			},
    	}
    },
    created: function() {

    },
    methods:{
    	//生成微信H5支付
    	createPay: function(){
    		createPayH5( this.payInfo )
    			.then( res=>{
    				if( res.status && ('h5Url' in res.response) ){
    					let url = res.response.h5Url;
    					window.location.href = url;
    				}else{

    				}
    			})
    			.catch( err=>{

    			})
    	}
    }
}
</script>